<template>
  <div class="habit max-w-full flex flex-col justify-between">
    <div>
      <header class="mint-header left-center-header">
        <router-link to="/tracker" class="justify-self-start">
          <i class="material-icons">arrow_back_ios_new</i>
        </router-link>
        <span>{{ dateHeader }}</span>
        <div></div>
      </header>

      <h1 class="text-center mt-4">
        {{ habit.name }}
        <span class="text-primary">notes</span>
      </h1>

      <p v-if="habit.description" class="text-center text-sm mt-2">
        {{ habit.description }}
      </p>

      <div class="flex flex-col justify-center items-center mt-4">
        <div class="h-screen-40 w-full flex justify-center mt-1 px-4">
          <t-textarea v-model="dataLog.notes" />
        </div>

        <label class="checkbox w-full mt-4">
          <span class="checkbox__input">
            <t-checkbox v-model="dataLog.isComplete" id="t-checkbox" />
            <span class="checkbox__control">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-width="3"
                  d="M1.73 12.91l6.37 6.37L22.79 4.59"
                />
              </svg>
            </span>
          </span>
          <span class="radio__label">
            {{ dataLog.isComplete ? 'Completed 🎉' : 'Not Completed' }}
          </span>
        </label>
      </div>
    </div>

    <div class="flex justify-center p-10">
      <t-button @click="save" :variant="{ success: isSaved }">
        {{ isSaved ? 'Saved' : 'Save' }}
      </t-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment/src/moment'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'Habit',
  props: ['habit', 'day', 'log', 'logIndex'],

  data() {
    return {
      dataLog: {
        day: this.day.id,
        habitId: this.habit.id,
        isComplete: false,
        notes: '',
        week: this.day.week,
        year: this.day.year
      },
      isSaved: false
    }
  },

  computed: {
    dateHeader() {
      const date = this.day.date.split('/')
      const month = moment(date[0]).format('MMM')
      const weekday = moment()
        .day(this.day.id)
        .format('dddd')
      return `${weekday} ${date[1]} ${month}`
    }
  },

  methods: {
    save() {
      let logId = this.log.id
      if (logId) {
        this.$store.commit('DELETE_LOG', this.logIndex)
      } else {
        logId = uuidv4()
      }

      this.$store.dispatch('setLog', {
        logId,
        log: this.dataLog
      })
      this.isSaved = true
      setTimeout(() => this.$router.push({ name: 'tracker' }), 800)
    }
  },

  mounted() {
    if (this.log) {
      this.dataLog = {
        habitId: this.log.habitId,
        isComplete: this.log.isComplete,
        notes: this.log.notes,
        date: this.log.date,
        month: this.log.month,
        week: this.log.week,
        weekday: this.log.weekday,
        year: this.log.year
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.habit {
  height: calc(100vh - 62px);
}
.checkbox {
  padding-left: 33%;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
  font-size: 1rem;
  color: rgb(31, 116, 255);
}
.checkbox__input {
  input {
    opacity: 0;
    width: 1em;
    height: 1em;
  }
}
.checkbox__control {
  display: inline-grid;
  width: 1em;
  height: 1em;
  border-radius: 0.25em;
  border: 0.1em solid currentColor;
}
.checkbox__input {
  display: grid;

  > * {
    grid-area: checkbox;
  }
}
.checkbox__control svg {
  transition: transform 0.1s ease-in 25ms;
  transform: scale(0);
  transform-origin: bottom left;
}
.checkbox__input input:checked + .checkbox__control svg {
  transform: scale(1);
}
.h-screen-40 {
  height: 40vh;
}
@media screen and (min-width: 768px) {
  .checkbox {
    margin-top: 2rem;
    padding-left: 42%;
  }
}
</style>
